import React from 'react'
import { createHashRouter, RouterProvider } from 'react-router-dom'
import Layout from '../Layout/Layout'
import Home from '../Home/Home'
import ProtectedRouter from '../ProtectedRouter/ProtectedRouter'
// import TV from '../TV/TV'
// import Movies from '../Movies/Movies'
import People from '../People/People'
// import Search from '../Search/Search'
import Login from '../Login/Login'
import Register from '../Register/Register'
import NotFound from '../NotFound/NotFound'
import Contact from '../Contact/Contact'
import About from '../About/About'
import ItemDetails from '../ItemDetails/ItemDetails'
import Profile from '../Profile/Profile'
import PopularMovies from '../Movies/PopularMovies/PopularMovies'
import TopRatedMovies from '../Movies/TopRatedMovies/TopRatedMovies'
import UpcomingMovies from '../Movies/UpcomingMovies/UpcomingMovies'
import PopularTVs from '../TV/PopularTVs/PopularTVs'
import TopRatedTVs from '../TV/TopRatedTVs/TopRatedTVs'
import OnAirTVs from '../TV/OnAirTVs/OnAirTVs'
import OnAirToDay from '../TV/OnAirToDay/OnAirToDay'
import SearchPeople from '../Search/SearchPeople/SearchPeople'
import SearchMovies from '../Search/SearchMovies/SearchMovies'
import SearchTVs from '../Search/SearchTVs/SearchTVs'
import ScrollToTop from '../ScrollToTop/ScrollToTop.jsx'











export default function App() {

  const routers = createHashRouter([
    {
      path: '/', element: <Layout />, children: [
        { index: true, element: <Home /> },
        { path: 'login', element: <Login /> },
        { path: 'register', element: <Register /> },
        { path: 'itemdetails/:id/:media_type', element: <ItemDetails /> },
        // { path: 'movies', element: <ProtectedRouter><Movies />, },
        { path: 'movies/popular', element: <PopularMovies /> },
        { path: 'movies/toprated', element: <TopRatedMovies /> },
        { path: 'movies/upcoming', element: <UpcomingMovies /> },
        // { path: 'tvshows', element:<TV /> },
        { path: 'tvshows/popular', element: <PopularTVs /> },
        { path: 'tvshows/toprated', element: <TopRatedTVs /> },
        { path: 'tvshows/onair', element: <OnAirTVs /> },
        { path: 'tvshows/onairtoday', element: <OnAirToDay /> },
        { path: 'people', element: <People /> },
        { path: 'search/people', element: <SearchPeople /> },
        { path: 'search/movies', element: <SearchMovies /> },
        { path: 'search/tvshows', element: <SearchTVs /> },
        { path: 'contact', element: <Contact /> },
        { path: 'about', element: <About /> },
        { path: 'profile', element: <Profile /> },
        { path: '*', element: <NotFound /> },
      ]
    }
  ])

  return (<>
    <RouterProvider router={routers} />
  </>
  )
}
